var map = {
	"./alelo.svg": 946,
	"./alipay.svg": 8996,
	"./american express.svg": 3612,
	"./amex.svg": 4302,
	"./aura.svg": 5088,
	"./code-front.svg": 7259,
	"./code.svg": 8302,
	"./diners.svg": 9222,
	"./discover.svg": 5170,
	"./elo.svg": 2696,
	"./generic-clean.svg": 9932,
	"./generic.svg": 7300,
	"./hiper.svg": 7609,
	"./hipercard.svg": 1305,
	"./jcb.svg": 7508,
	"./maestro.svg": 8506,
	"./mastercard.svg": 2652,
	"./mir.svg": 1600,
	"./paypal.svg": 1761,
	"./sodexo.svg": 9385,
	"./unionpay.svg": 9459,
	"./visa.svg": 1594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1606;